import queryString from 'query-string';

// A party shares two application links per election: the open one and a
// "trusted" one that differs only by `&trusted=1`. The marker is read from the
// URL into page state once, on the application page; it is never an input the
// applicant can see or toggle, and it never travels inside the `guid` string.
export const TRUSTED_QUERY_PARAM = 'trusted';

/**
 * True only when the query string carries `trusted=1` exactly once. Anything
 * else — `true`, `0`, an empty value, a repeated param (parsed as an array) or
 * a missing key — is the open link.
 */
export const readTrustedInvite = (search: string): boolean => {
	const value = queryString.parse(search)[TRUSTED_QUERY_PARAM];
	return value === '1';
};

/**
 * The POST /Volunteer fields the invite type contributes. On the trusted link
 * the body carries exactly `isTrustedAgent: true`; on the open link the key is
 * ABSENT — not `false`. Spread the result into the payload so the open link
 * never makes a claim about trust in either direction.
 */
export const trustedPayloadFields = (isTrusted: boolean): { isTrustedAgent: true } | Record<string, never> =>
	isTrusted ? { isTrustedAgent: true } : {};
